import {
  Component,
} from '@angular/core';
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { MobileDiaryListContentComponent } from "./diary-list-content/mobile-diary-list-content";

@Component({
  selector: 'app-mobile-diary-list',
  styleUrls: ['./mobile.diary-list.component.scss'],
  templateUrl: './mobile.diary-list.component.html',
  imports: [
    MobilePageContentComponent,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    MobileDiaryListContentComponent
  ],
  standalone: true
})
export class MobileDiaryListComponent {

}
